/* Accessibility metadata for Shopify-generated controls; no visual or click changes. */
(() => {
  const start = () => {
    const noticeId = 'a11y-new-window-message';
    const linkSelector = '#shopify-pc__banner__body-policy-link, [data-a11y-powered-by] a';
    const frameSelector = 'iframe#PBarNextFrame, iframe[id^="web-pixel-sandbox-CUSTOM-shopify-custom-pixel-LAX-"]';
    const hosts = new Map();

    const nameFrame = (frame) => {
      if (frame.title.trim()) return;
      // Name the injected frame without changing its visibility, source or sandbox.
      frame.title = frame.id === 'PBarNextFrame' ? 'Shopify theme preview toolbar' : 'Shopify analytics sandbox';
    };

    const describeLink = (link) => {
      if (!document.getElementById(noticeId)) return;
      const ids = (link.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
      const needsNotice = link.target.toLowerCase() === '_blank';
      if (needsNotice && !ids.includes(noticeId)) {
        link.setAttribute('aria-describedby', [...ids, noticeId].join(' '));
      } else if (!needsNotice && ids.includes(noticeId)) {
        const remaining = ids.filter((id) => id !== noticeId);
        if (remaining.length) link.setAttribute('aria-describedby', remaining.join(' '));
        else link.removeAttribute('aria-describedby');
      }
    };

    const repairFollowGraphics = (root) => {
      root.querySelectorAll('button svg[role="img"][viewBox="0 0 60 25"]').forEach((logo) => {
        const name = logo.querySelector('title')?.textContent.trim();
        // Retain Shopify's name; make the existing title explicit for ARIA checks.
        if (name && !logo.hasAttribute('aria-label') && !logo.hasAttribute('aria-labelledby')) {
          logo.setAttribute('aria-label', name);
        }
      });
      // The small unlabeled heart sits beside Shopify's separately named Shop logo.
      // Leave artwork, interactive SVGs and button behavior intact.
      root.querySelectorAll('button svg[viewBox="0 0 20 20"]').forEach((svg) => {
        if (svg.matches('[role], [aria-label], [aria-labelledby], [tabindex]') || svg.querySelector('title, desc')) return;
        const button = svg.closest('button');
        if (!button.querySelector('svg[role="img"] title')?.textContent.trim()) return;
        if (svg.getAttribute('aria-hidden') !== 'true') svg.setAttribute('aria-hidden', 'true');
        if (svg.getAttribute('focusable') !== 'false') svg.setAttribute('focusable', 'false');
      });
    };

    const trackFollowButton = (host) => {
      if (hosts.has(host)) return;
      const state = { observer: null, timer: null, attempts: 0 };
      hosts.set(host, state);
      const connect = () => {
        clearTimeout(state.timer);
        state.timer = null;
        if (!host.isConnected || state.observer) return;
        if (host.shadowRoot) {
          repairFollowGraphics(host.shadowRoot);
          state.observer = new MutationObserver(() => repairFollowGraphics(host.shadowRoot));
          state.observer.observe(host.shadowRoot, {
            childList: true, subtree: true, attributes: true,
            attributeFilter: ['aria-hidden', 'focusable', 'aria-label', 'aria-labelledby'],
          });
        } else if (state.attempts++ < 20) {
          // Bounded fallback for asynchronously attached roots; no perpetual polling.
          state.timer = setTimeout(connect, 500);
        }
      };
      connect();
      customElements.whenDefined('shop-follow-button').then(() => {
        if (hosts.get(host) !== state) return;
        state.attempts = 0;
        connect();
      });
    };

    const scan = (root) => {
      if (root.nodeType !== Node.ELEMENT_NODE) return;
      if (root.matches(linkSelector)) describeLink(root);
      root.querySelectorAll(linkSelector).forEach(describeLink);
      if (root.matches(frameSelector)) nameFrame(root);
      root.querySelectorAll(frameSelector).forEach(nameFrame);
      if (root.matches('shop-follow-button')) trackFollowButton(root);
      root.querySelectorAll('shop-follow-button').forEach(trackFollowButton);
    };

    scan(document.body);
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'attributes') {
          if (record.target.matches(linkSelector)) describeLink(record.target);
          if (record.target.matches(frameSelector)) nameFrame(record.target);
        } else {
          record.addedNodes.forEach(scan);
        }
      }
      // Theme-editor section replacement must not retain detached shadow trees.
      for (const [host, state] of hosts) {
        if (!host.isConnected) {
          state.observer?.disconnect();
          clearTimeout(state.timer);
          hosts.delete(host);
        }
      }
    });
    observer.observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['target', 'aria-describedby', 'title', 'id'],
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
